import React, { useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { 
  FiBox, FiBriefcase, FiShoppingCart, FiFileText, FiBookOpen, 
  FiUsers, FiFolder, FiCalendar, FiTag, FiTool, FiMessageSquare, 
  FiMonitor, FiUser, FiBell, FiShare2, FiPrinter, FiStar, 
  FiChevronDown, FiHome, FiLogOut 
} from 'react-icons/fi';
import { FaBuilding } from 'react-icons/fa';

const TopNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const navItems = [
    { icon: FiHome, label: 'Dash...', path: '/dashboard', color: 'text-[#0000a0]' },
    { icon: FiUsers, label: 'CRM', path: '/crm/third-parties', color: 'text-[#ff00ff]' },
    { icon: FiFileText, label: 'Sales', path: '/sales/proposals', color: 'text-[#ff8c00]' },
    { icon: FiShoppingCart, label: 'Purch...', path: '/purchase/records', color: 'text-[#800080]' },
    { icon: FiBox, label: 'MRP', path: '/mrp', color: 'text-[#8b4513]' },
    { icon: FiBriefcase, label: 'Proje...', path: '/projects', color: 'text-[#008080]' },
    { icon: FaBuilding, label: 'Bank...', path: '/bank/accounts', color: 'text-[#0000cd]' },
    { icon: FiBookOpen, label: 'Acco...', path: '/accounting/bind', color: 'text-[#ff8c00]' },
    { icon: FiUsers, label: 'HRM', path: '/hrm/employees', color: 'text-[#eab308]' },
    { icon: FiFolder, label: 'Docu...', path: '/documents', color: 'text-[#1e90ff]' },
    { icon: FiCalendar, label: 'Agenda', path: '/hrm/leaves', color: 'text-[#1e90ff]' },
    { icon: FiTag, label: 'Tickets', path: '/hrm/presences', color: 'text-[#ff0000]' },
    { icon: FiTool, label: 'Tools', path: '/tools', color: 'text-[#808080]' },
    { icon: FiMessageSquare, label: 'Moce...', path: '/moceanapi', color: 'text-[#eab308]' },
    { icon: FiMonitor, label: 'POS', path: '/pos', color: 'text-[#ff0000]' },
  ];

  const handleLogout = () => {
    // 這裡可以加入清除 token 或 localStorage 的邏輯
    setShowProfileMenu(false);
    navigate('/');
  };

  return (
    <div className="bg-[#a6e4e7] border-b border-[#8ed1d4] flex justify-between items-center px-2 py-0 shadow-sm h-[60px]">
      <div className="flex space-x-0 overflow-x-auto h-full">
        {navItems.map((item, idx) => (
          <Link 
            key={idx} 
            to={item.path} 
            className={`flex flex-col items-center justify-center w-[52px] h-full hover:bg-white/20 transition-colors ${
              location.pathname.startsWith(item.path.split('/')[1] ? `/${item.path.split('/')[1]}` : item.path) 
                ? 'bg-white/30 border-b-[3px] border-[#0000a0]' 
                : 'border-b-[3px] border-transparent'
            }`}
          >
            <item.icon className={`text-[22px] ${item.color}`} />
            <span className="text-[10px] mt-1 text-gray-800 font-medium truncate w-full text-center px-0.5">{item.label}</span>
          </Link>
        ))}
      </div>

      <div className="flex items-center space-x-4 text-[12px] pr-2 h-full">
        <span className="text-teal-900 font-bold mr-1 hidden md:block">WY Limited</span>
        
        {/* Updated Top Right Tools Icons */}
        <div className="flex items-center space-x-3 text-gray-600 text-lg">
          <FiBell className="cursor-pointer hover:text-[#0000a0] transition-colors" title="Notifications" />
          <FiMessageSquare className="cursor-pointer hover:text-[#0000a0] transition-colors" title="Messages" />
          <FiShare2 className="cursor-pointer hover:text-[#0000a0] transition-colors" title="Share" />
          <FiPrinter className="cursor-pointer hover:text-[#0000a0] transition-colors" title="Print" />
          <FiStar className="cursor-pointer hover:text-yellow-500 transition-colors" title="Bookmarks" />
          <FiChevronDown className="cursor-pointer hover:text-[#0000a0] transition-colors text-sm" />
        </div>

        {/* User Profile & Dropdown */}
        <div className="relative">
          <div 
            className="flex items-center space-x-1.5 cursor-pointer hover:bg-white/30 ml-2 bg-white/20 px-2.5 py-1.5 rounded-full transition-colors border border-teal-200/50"
            onClick={() => setShowProfileMenu(!showProfileMenu)}
          >
            <div className="bg-teal-600 rounded-full p-1">
              <FiUser className="text-white text-xs" />
            </div>
            <span className="font-bold text-teal-900">Wan Yee</span>
            <FiChevronDown className="text-[10px] text-teal-900" />
          </div>

          {/* Dropdown Menu */}
          {showProfileMenu && (
            <>
              {/* Invisible overlay to close dropdown when clicking outside */}
              <div 
                className="fixed inset-0 z-40" 
                onClick={() => setShowProfileMenu(false)}
              ></div>
              
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 border border-gray-200 z-50">
                <div className="px-4 py-3 border-b border-gray-100">
                  <p className="text-[13px] font-bold text-gray-800">Wan Yee Lui</p>
                  <p className="text-[11px] text-gray-500 truncate mt-0.5">wanyee@wylimited.com</p>
                </div>
                <div className="py-1">
                  <button 
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-2 text-[13px] text-red-600 hover:bg-red-50 flex items-center transition-colors font-medium"
                  >
                    <FiLogOut className="mr-2 text-sm" /> 
                    Logout
                  </button>
                </div>
              </div>
            </>
          )}
        </div>

      </div>
    </div>
  );
};

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#a6e4e7]">
      <TopNav />
      <div className="flex-1 flex overflow-hidden">
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}